<template>
  <div>
    <v-layout align-center>
      <v-flex shrink>
        <div class="title">
          <span class="mr-3">Workers</span>
        </div>
      </v-flex>
      <v-spacer/>
      <v-flex shrink>
        <v-btn
          class="ma-0"
          icon
          @click="add">
          <v-icon>add</v-icon>
        </v-btn>
        <v-btn
          v-if="expand === 0 && workers.length > 0"
          class="ma-0"
          icon
          @click="expand = -1">
          <v-icon>expand_less</v-icon>
        </v-btn>
        <v-btn
          v-else
          :disabled="workers.length === 0"
          class="ma-0"
          icon
          @click="expand = 0">
          <v-icon>expand_more</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-progress-linear
      v-if="deleting"
      class="ma-0"
      color="grey"
      height="1"
      indeterminate/>
    <v-divider v-else/>
    <v-expansion-panel
      v-if="workers.length > 0"
      :value="expand">
      <v-expansion-panel-content>
        <v-data-table
          :headers="headers"
          :items="workers"
          hide-actions>
          <template
            slot="items"
            slot-scope="props">
            <td>{{ props.item.firstName }}</td>
            <td>{{ props.item.lastName }}</td>
            <td>{{ props.item.contact }}</td>
            <td class="justify-center layout px-0">
              <v-btn
                icon
                class="mx-0"
                @click="edit(props.item)">
                <v-icon small>edit</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-0"
                @click="del(props.item)">
                <v-icon small>delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="no-data"/>
        </v-data-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-dialog
      v-model="dialog"
      max-width="30rem"
      persistent>
      <v-card>
        <v-card-text>
          <v-form v-model="valid">
            <v-container grid-list-sm>
              <v-layout>
                <v-flex>
                  <v-text-field
                    v-model="worker.firstName"
                    :rules="[v => !!v || 'First name is required']"
                    label="First name"/>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-text-field
                    v-model="worker.lastName"
                    :rules="[v => !!v || 'Last name is required']"
                    label="Last name"/>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-textarea
                    v-model="worker.contact"
                    auto-grow
                    rows="1"
                    label="Contact information"/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            :disabled="posting"
            flat
            @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn
            :disabled="posting || !valid"
            flat
            @click="save">
            <v-progress-circular
              v-if="posting"
              indeterminate/>
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "workers-table",
  props: {
    workers: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      defaultWorker: {
        firstName: "",
        lastName: "",
        contact: ""
      },
      deleting: false,
      dialog: false,
      expand: 0,
      headers: [
        {
          text: "First name",
          value: "firstName"
        },
        {
          text: "Last name",
          value: "lastName"
        },
        {
          text: "Contact",
          value: "contact"
        },
        {
          text: "Actions",
          value: "actions",
          align: "center",
          sortable: false,
          width: "10%"
        }
      ],
      index: -1,
      posting: false,
      valid: false,
      worker: {}
    };
  },
  methods: {
    add () {
      this.index = -1;
      this.worker = Object.assign({}, this.defaultWorker);
      this.dialog = true;
    },
    edit (r) {
      this.index = this.workers.indexOf(r);
      this.worker = Object.assign({}, r);
      this.dialog = true;
    },
    del (r) {
      if (confirm("Are you sure you want to delete this worker?")) {
        const updatedWorkers = Array.from(this.workers);
        updatedWorkers.splice(updatedWorkers.indexOf(r), 1);
        this.deleting = true;
        this.$http.
          put(
            `/api/franchises/${this.$route.params.id}`,
            { workers: updatedWorkers }
          ).
          then(() => {
            this.deleting = false;
            this.dialog = false;
            this.$emit("refresh");
          }).
          catch(() => this.deleting = false);
      }
    },
    save () {
      let updatedWorkers = Array.from(this.workers);
      if (this.index > -1) {
        Object.assign(updatedWorkers[this.index], this.worker);
        this.posting = true;
        this.$http.
          put(
            `/api/franchises/${this.$route.params.id}`,
            { workers: updatedWorkers }
          ).
          then(() => {
            this.posting = false;
            this.dialog = false;
            this.$emit("refresh");
          }).
          catch(() => this.posting = false);
      } else {
        if (this.workers.length === 0) {
          updatedWorkers = [Object.assign({}, this.worker)];
        } else {
          updatedWorkers.push(Object.assign({}, this.worker));
        }
        this.posting = true;
        this.$http.
          put(
            `/api/franchises/${this.$route.params.id}`,
            { workers: updatedWorkers }
          ).
          then(() => {
            this.posting = false;
            this.dialog = false;
            this.$emit("refresh");
          }).
          catch(() => this.posting = false);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Franchise/WorkersTable.vue